import { render, staticRenderFns } from "./TypeMarquee.vue?vue&type=template&id=1aaa09da&scoped=true&"
import script from "./TypeMarquee.vue?vue&type=script&lang=js&"
export * from "./TypeMarquee.vue?vue&type=script&lang=js&"
import style0 from "./TypeMarquee.vue?vue&type=style&index=0&id=1aaa09da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa09da",
  null
  
)

export default component.exports